import createReactComponent from '../createReactComponent';
export default createReactComponent('bookmark-edit', 'IconBookmarkEdit', [
  [
    'path',
    {
      d: 'M11.35 17.39l-4.35 2.61v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v6',
      key: 'svg-0',
    },
  ],
  [
    'path',
    {
      d: 'M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z',
      key: 'svg-1',
    },
  ],
]);
